/*
 * Workspace Messages
 *
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  permissionOwner: {
    id: 'app.permissionLevels.Owner',
    defaultMessage: 'Owner',
  },
  permissionContributor: {
    id: 'app.permissionLevels.Contributor',
    defaultMessage: 'Contributor',
  },
  permissionReviewer: {
    id: 'app.permissionLevels.Reviewer',
    defaultMessage: 'Reviewer',
  },
  actionRemove: {
    id: 'app.actions.remove',
    defaultMessage: 'Remove',
  },
});
